import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUser } from '~/interfaces/user';

export const userInitialState = Object.freeze<IUser>({
  isAuthenticated: false,
  authToken: null,
});

const userSlice = createSlice({
  name: 'user',
  initialState: userInitialState,
  reducers: {
    setUser: (_state, action: PayloadAction<IUser>) => action.payload,
  },
});

export const { setUser } = userSlice.actions;

export default userSlice.reducer;
